@if (iconSet() && showWidget()) {
  <div class="row mt-4 mx-4 lg:ml-0">
    @if (financialData()) {
      <div class="widget-card card mx-0 bg-white" data-cy="financialWidget">
        <div class="header-row flex">
          <h4>Financial Information</h4>
          <span data-cy="asOfDate">as of {{selectedAsOfDate() | dateFormat : 'MM/dd/yyyy'}}</span>
        </div>
        <!-- Dynamic Financial Fields Rendering -->
        <div class="row grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-6 lg:gap-0 inner-row px-5 pt-5"
          [attr.data-cy]="getContainerDataCy()">
          
          @for (field of financialFields(); track field.label) {
            <div [ngClass]="field.label === 'Underwritten Hold Term' ? 'pr-2.5 lg:pr-0 pl-5':''">
              <div class="pr-2.5 lg:pr-0 lg:float-left lg:relative">
                <div class="text-right" [ngClass]="isLargeLeftTextAligned(field) ? 'lg:text-left' : ''">
                    <img class="icon" [src]="field.icon" [alt]="field.label">
                </div>
                <div class="value text-md md:text-lg text-right" 
                  [ngClass]="isLargeLeftTextAligned(field) ? 'lg:text-left' : ''"
                  [attr.data-cy]="field.dataCy">
                  @if (field.value === null || field.value === undefined) {
                    N/A
                  } @else if (field.value === 0 && field.type !== 'text') {
                    -
                  } @else {
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | toNumber | currencyFormat:'USD':'Billions' }}
                      }
                      @case ('percentage') {
                        {{ field.value | toNumber | percentageValueFormat }}
                      }
                      @case ('number') {
                        {{ field.value | toNumber | tvpiValueFormat:true }}
                      }
                      @case ('text') {
                        {{ field.value | toString | standardStringFormat }}
                      }
                    }
                  }
                </div>
                <div class="title text-md md:text-lg text-right" [ngClass]="isLargeLeftTextAligned(field) ? 'lg:text-left' : ''">
                  {{ field.label }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}